module.exports = __webpack_public_path__ + "img/无数据.a079bd4b.svg";